import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GaTrackingEventLabel } from '../../constants';

export class GATrackingPdpSellerInteractionEvent implements GATrackingEvent {
  constructor(private payload: any) {}

  getEventType(): any {
    return this.payload.action;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.PdpSellerInteraction,
      label: GaTrackingEventLabel.PdpSellerInteraction.replace('{seller}', this.payload.label),
      gtmCustom: {
        category: this.payload.category
      }
    };
  }
}
